import { render, staticRenderFns } from "./JoLoadMoreFixed.vue?vue&type=template&id=25ef2579&scoped=true&"
import script from "./JoLoadMoreFixed.vue?vue&type=script&lang=js&"
export * from "./JoLoadMoreFixed.vue?vue&type=script&lang=js&"
import style0 from "./JoLoadMoreFixed.vue?vue&type=style&index=0&id=25ef2579&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef2579",
  null
  
)

export default component.exports